const PrivacyPolicy =()=> {
    return (
        'Content coming soon'
    )
}

export default PrivacyPolicy;